import CollectionGridComponent from "./CollectionGridComponent";

export default CollectionGridComponent